import { render, staticRenderFns } from "./page-header-group.vue?vue&type=template&id=bc0f920e&scoped=true"
import script from "./page-header-group.vue?vue&type=script&lang=js"
export * from "./page-header-group.vue?vue&type=script&lang=js"
import style0 from "./page-header-group.vue?vue&type=style&index=0&id=bc0f920e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc0f920e",
  null
  
)

export default component.exports